import { HTMLAttributes, useRef } from "react";
import { classNames } from "../../../utils/classNames";
import Spinner from "../Spinner";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

interface Props extends HTMLAttributes<HTMLButtonElement> {
  label: string;
  isLoading?: boolean;
  disabled?: boolean;
  type?: "submit" | "button";
}

const Button = (props: Props) => {
  const {
    label,
    type = "button",
    isLoading = false,
    disabled = false,
    autoFocus,
    ...other
  } = props;

  const buttonRef = useRef<HTMLButtonElement | null>(null);

  return (
    <>
      <button
        type={type}
        ref={buttonRef}
        disabled={isLoading || disabled}
        className={classNames(
          isLoading || disabled
            ? tw`border-gray-500 text-gray-500`
            : tw`border-primary text-primary`,
          tw`px-2 border py-2 rounded my-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`
        )}
        {...other}
      >
        {isLoading ? <Spinner /> : label}
      </button>
    </>
  );
};

export default Button;
